import type { AllowedHoursEntity, Company } from './company'
import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'

export class CompaniesRepository extends BaseRepository<Company> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/' + 'companies', token, cache)
    }

    async getAlert(key: string): Promise<{ date: Date; value: { message: string; interval: number; device: string } }> {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/companies/alert/' + key + '?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getPublicCompany(companyId: string) {
        const { json, statusCode, message } = await this.request.get(this.config.userApiUrl + '/companies/' + companyId + '/public')
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async confidenceUnlock(companyId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/companies/' + companyId + '/confidence-unlock?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async delayCardRenew(companyId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/companies/' + companyId + '/delay-card-renew?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async assignUser(companyId: string, userId: string) {
        const { json, statusCode, message } = await this.request.post(
            this.config.userApiUrl + '/companies/' + companyId + '/users/?token=' + this.resolvedToken,
            { userId },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async setAllowLogin(userId: string, allowLogin: boolean, allowedHours: AllowedHoursEntity) {
        const { json, statusCode, message } = await this.request.post(
            this.config.userApiUrl + '/companies/' + this.store.token.companyId + '/allow-login/?token=' + this.resolvedToken,
            { userId, allowLogin, allowedHours },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getAllowLogin(userId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.userApiUrl + '/companies/' + this.store.token.companyId + '/allow-login/' + userId + '?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async removeUser(companyId: string, userId: string) {
        const url = this.config.userApiUrl + '/companies/' + companyId + '/users/' + userId + '/?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.delete(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getCompanyUsers(companyId: string, useCacheIfNewerThanThisInSeconds: number = 0) {
        const url = this.config.userApiUrl + '/companies/' + companyId + '/users/?token=' + this.resolvedToken
        if (useCacheIfNewerThanThisInSeconds > 0) {
            const cached = this.resolvedCache.get(url, useCacheIfNewerThanThisInSeconds)
            if (cached) return cached
        }
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') {
            this.resolvedCache.set(url, json, url.split('/')[2])
            return json
        }
        throw message
    }
}
